/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */

// stupid storage implementation:
export var app_logs = {
    last_read_idx: 0,
    logs: {
        logCount: 0,
        message_queue: []
    }
}

export var app_log = {

    log(message, priority) {
        var m_id = app_logs.logs.logCount++
        app_logs.logs.message_queue.push({
            message: message,
            priority: priority,
            m_id: m_id
        })
    },

    info(message) {
        this.log(message, 2);
    },

    warn(message) {
        this.log(message, 1);
    },

    error(message) {
        this.log(message, 0);
    },

    methods: {
        loggerPop() {
            return app_logs.logs.message_queue.pop()
        },

        getLastLog() {
            if(app_logs.logs.message_queue.length >= 1) {
                return app_logs.logs.message_queue[app_logs.logs.message_queue.length - 1]
            }
            return null
        },

        getUnreadLogs() {
            var ret = app_logs.logs.message_queue.slice(app_logs.last_read_idx);
            if (ret != []) {
                app_logs.last_read_idx = app_logs.logs.message_queue.length;
            }
            return ret;
        },
    }
}